import Vue from "vue";
import App from "./App";
import router from "@router";
import store from "@store";
import axios from "axios";
import VueAxios from "vue-axios";
import "@components/_globals";
import BootstrapVue from "bootstrap-vue";
import moment from "moment";
import { VueMaskDirective } from "v-mask";
import VueCharts from "vue-chartjs";
import Dialog from "bootstrap-vue-dialog";
import VueLodash from "vue-lodash";
import lodash from "lodash";
import { helper } from "@utils/helper.js";

Vue.directive("mask", VueMaskDirective);
Vue.use(VueLodash, { name: "custom", lodash: lodash });
Vue.use(VueAxios, axios);
Vue.use(Dialog);

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === "production";

Vue.use(BootstrapVue);

Vue.filter("formatField", function(value, type) {
  if (type === null || type === undefined) return value;
  if (value === null || value === undefined) return "-";
  if (type == "boolean") return value === true ? "Sim" : "Não";
  if (type == "date")
    return moment(new Date(value))
      .locale("pt-br")
      .format("DD/MM/YYYY");
  if (type == "extdate")
    return moment(String(value))
      .locale("pt-br")
      .format("dddd, DD [de] MMMM [de] YYYY");
  if (type == "calendar")
    return moment(String(value))
      .locale("pt-br")
      .calendar();
  if (type == "time") return String(value).substring(0, 5);
  if (type == "moment-time")
    return moment(String(value))
      .locale("pt-br")
      .format("HH:mm");
  if (type == "datetime")
    return moment(String(value))
      .locale("pt-br")
      .format("DD/MM/YYYY hh:mm");
  if (type == "money") {
    let val = (value / 1).toFixed(2).replace(".", ",");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  if (typeof value == "object" && type) {
    let val = value;
    type.split(".").forEach(element => {
      val = val[element];
    });
    return val;
  }
  return value;
});

Vue.use(VueCharts);

Vue.prototype.$helper = helper;

const app = new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");

// If running e2e tests...
if (process.env.VUE_APP_TEST === "e2e") {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app;
}
